/**
 * Latest published CryptoGuardians Snap version.
 * Update this constant when a new Snap version is released.
 * Used by the upgrade detection UI to compare against the user's installed version.
 */
export const LATEST_SNAP_VERSION = '1.1.1';
